import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-color-black ns-p-0 ${className}`}
            onClick={() => filter.remove()}
            style="padding-left: 2px;"
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters">
                <a
                    href="javascript:void(0)"
                    class="ns-selected-filter ns-clear-filters"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear Filters
                </a>
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div class="ns-selected-filter ns-d-flex ns-align-items-center">
                            <span class="">{filter.value}</span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                {/*  */}
            </div>
        )
    )
}
